/**
 * Entity klasa Session - zarządza tokenami i sesją
 * Przechowuje info o current session (z refresh tokena)
 */
export class SessionEntity {
  accessToken: string;
  refreshToken?: string;
  issuedAt: Date;
  expiresAt: Date;
  rotationCount: number;

  constructor(accessToken: string, expiresInSeconds: number = 900, refreshToken?: string, rotationCount: number = 0) {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.issuedAt = new Date();
    this.expiresAt = new Date(Date.now() + expiresInSeconds * 1000);
    this.rotationCount = rotationCount;
  }

  /**
   * Czy access token jest ważny?
   */
  get isAccessTokenValid(): boolean {
    return new Date() < this.expiresAt;
  }

  /**
   * Czy token wkrótce wygaśnie? (w ciągu 1 minuty)
   */
  get isAccessTokenExpiringSoon(): boolean {
    const oneMinuteFromNow = new Date(Date.now() + 60000);
    return this.expiresAt < oneMinuteFromNow;
  }

  /**
   * Ile czasu zostało tokenu (w ms)
   */
  get timeRemaining(): number {
    return Math.max(0, this.expiresAt.getTime() - new Date().getTime());
  }

  /**
   * Zaktualizuj token
   */
  updateToken(newAccessToken: string, expiresInSeconds: number, newRefreshToken?: string): void {
    this.accessToken = newAccessToken;
    this.refreshToken = newRefreshToken || this.refreshToken;
    this.issuedAt = new Date();
    this.expiresAt = new Date(Date.now() + expiresInSeconds * 1000);
    this.rotationCount++;
  }

  /**
   * Wyczyść sesję
   */
  clear(): void {
    this.accessToken = '';
    this.refreshToken = undefined;
    this.issuedAt = new Date(0);
    this.expiresAt = new Date(0);
    this.rotationCount = 0;
  }
}
